import React, { FC } from 'react';

import { ArrowRightOutlined } from '@ant-design/icons';
import { NOMENCLATURE_UAH } from '@app/shared/constants/globalConstans';
import { StyledResourceCard } from '@components/shared/ResourceCard/ResourceCard.style';
import { IResourceCardProps } from '@components/shared/ResourceCard/types';
import { formatNumberWithDecimals } from '@utils/shared/number/formatNumberWithDecimals';
import { formatReadableNumber } from '@utils/shared/number/formatReadableNumber';
import { Divider, Flex, Typography } from 'antd';
import clsx from 'clsx';
import { t } from 'i18next';
import { Link } from 'react-router-dom';

const { Text } = Typography;

export const ResourceCard: FC<IResourceCardProps> = ({
	isMain ,
	walletName,
	walletId,
	nomenclatures,
}) => (
	<StyledResourceCard vertical gap={8} className={clsx('card w-full', isMain && 'main')}>
		<Flex gap={8} align='center' justify='space-between'>
			<Text type='secondary' className='title'>
				{walletName}
			</Text>

			{walletId && (
				<Link to={`/wallets/${walletId}`}>
					<ArrowRightOutlined className='text-green' />
				</Link>
			)}
		</Flex>

		<Divider style={{ margin: '0' }} />

		{!!nomenclatures.length ? (
			<>
				{nomenclatures?.map(({ nomenclature, nomenclatureName, balance }) => (
					<Flex
						key={nomenclature}
						justify='space-between'
						align='center'
						gap={16}
						className={clsx('nomenclature-wrapper', nomenclature === NOMENCLATURE_UAH && 'uah')}>
						<Text>{nomenclatureName}</Text>
						<Text>{formatReadableNumber(formatNumberWithDecimals(balance))}</Text>
					</Flex>
				))}
			</>
		) : (
			<Flex className='nomenclature-wrapper uah'>
				<Text>{t('wallet.resourceSummary.summaryBalanceEmpty')}</Text>
			</Flex>
		)}
	</StyledResourceCard>
);
